import React from "react";

// Shared visual design for the auth screens. Mirrors Login.tsx (the reference).
export const authInputClassName =
  "block w-full rounded-lg border border-zinc-200/90 bg-white px-4 py-3 text-base text-zinc-900 placeholder:text-zinc-400 shadow-sm transition-colors focus:border-brand-primary focus:outline-none focus:ring-2 focus:ring-brand-primary";

export const authLabelClassName =
  "mb-1.5 block text-sm font-medium text-zinc-700";

export const authButtonClassName =
  "flex w-full justify-center rounded-lg bg-brand-primary px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-primary-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary disabled:opacity-60";

export const authLinkButtonClassName =
  "text-sm font-medium text-brand-primary-light hover:text-brand-primary focus:outline-none focus-visible:underline";

export const authIconButtonClassName =
  "absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-600 focus:outline-none";

export const AuthError: React.FC<{ message: string }> = ({ message }) => (
  <div className="rounded-lg border border-red-200 bg-red-50 p-4">
    <div className="text-sm text-red-800">{message}</div>
  </div>
);

interface AuthLayoutProps {
  title: string;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  title,
  subtitle,
  children,
}) => (
  <div className="flex min-h-screen flex-col items-center justify-start bg-zinc-50 px-4 pb-16 pt-12">
    <div className="flex w-full max-w-md flex-col items-center">
      <div className="mb-10 flex flex-col items-center">
        <img
          className="mb-4 h-24 w-24 object-contain"
          src="/sagelyn-circle.png"
          alt="Sagelyn"
          onError={(e) => {
            e.currentTarget.src = "https://via.placeholder.com/64x64?text=S";
          }}
        />
        <h1 className="text-lg font-semibold tracking-tight text-brand-primary">
          Sagelyn
        </h1>
        <h2 className="mt-3 text-center text-xl font-semibold text-zinc-900">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-1 text-center text-sm text-zinc-500">{subtitle}</p>
        )}
      </div>

      {children && (
        <div className="w-full rounded-xl border border-zinc-200/90 bg-white p-6 shadow-sm sm:p-8">
          {children}
        </div>
      )}

      <p className="mt-10 text-center text-xs text-zinc-500">
        Powered by DaisyAI, LLC
      </p>
    </div>
  </div>
);

export default AuthLayout;
